import React, {useEffect, useState} from 'react'
import cn from 'classnames'
import styles from './payout.module.sass'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Card from '../../../../Card'
import TextInput from '../../../../TextInput'
import Switch from '../../../../Switch'
import TextArea from '../../../../TextArea'
import Radio from '../../../../Radio'
import Item from '../../../../Schedule/Item'
import DatePicker from "react-datepicker";
import { format } from "date-fns";

const Payout = ({className, onClose}) => {
  
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  // Schedule
  const [schedule, setSchedule] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [startTime, setStartTime] = useState('')
  const [endDate, setEndDate] = useState('')
  const [endTime, setEndTime] = useState('')

  const [visibleStartDate, setVisibleStartDate] = useState(false);
  const [visibleStartTime, setVisibleStartTime] = useState(false);
  const [visibleEndDate, setVisibleEndDate] = useState(false);
  const [visibleEndTime, setVisibleEndTime] = useState(false);
  
  return (
    <>
      <div className={styles.container}>
        <div className={styles.deposit}>
            <div className={styles.modalHeading}>
                <div className={styles.block}></div><span>Payout</span>
            </div>
            <div className={styles.modalBody}>
                
                <div className={styles.wrapper}>
                    <div className={styles.group}>
                        <TextInput className={styles.field} label='Transaction Source' value='Specter Bank' disabled />
                        <TextInput className={styles.field} label='Transaction Contact' placeholder='Enter Transaction Contact' />
                    </div>

                    <div className={styles.group}>
                        <TextInput className={styles.field} label='Transaction Recipient'  placeholder='Enter Transaction Recipient' />
                        <TextInput className={styles.field} label='Transaction Amount' placeholder='Enter Transaction Amount' />
                    </div>

                    <div className={styles.group}>
                        <TextInput className={styles.field} label='Transaction Purpose Type' placeholder='Enter Transaction Purpose Type' />
                        <TextInput className={styles.field} label='Transaction Event' placeholder='Enter Transaction Event' />
                    </div>

                    <div className={styles.radioGroup}>
                        <div className={styles.radio}>
                            <div className={styles.radioLabel}>
                                <span>Schedule Payout</span>
                            </div>
                            <div className={styles.variants}>
                                <Radio className={styles.radioInput} name="schedule" value={!schedule} onChange={() => setSchedule(false)} content="Immediate" />
                                <Radio className={styles.radioInput} name="schedule" value={schedule} onChange={() => setSchedule(true)} content="Set Date/Time" />
                            </div>
                        </div>
                    </div>

                    <TextArea  rows={5} label="Transaction Notes" />

                </div>
                
            </div>
            <div className={styles.modalFooter}>
                <button className={cn(styles.button, 'button-save-small')}>Save</button>
                <button className={cn(styles.button, 'button-cancel-small')} onClick={onClose}>Cancel</button>
            </div>
        </div>
      </div>
    </>
  )
}

export default Payout